<template>
  <v-btn
    color="primary"
    large
    text
    :loading="loading"
    @click="copySecret"                  
  >
    Make global
  </v-btn>
</template>
<script>
  import axios from 'axios'
  export default {
    name: 'SecretButton',
    props: {
      universe: String,
      secret: String,
    },
    data () {
      return {
        loading: false,
      }
    },
    methods: {
      async copySecret () {
        this.loading = true
        await axios.get(`/api/universes/get/${this.universe}/secrets/get/${this.secret}/copy`)
        this.loading = false
        this.$store.commit('app/feedbackMessage', `Secret ${this.secret} copied over universes.`)
        this.$store.commit('app/feedbackColor', 'success')
        this.$store.commit('app/displayFeedback', true)
      },
    },
  }
</script>
